<template>
  <div>
    <router-link :to="`/index`">
      <p id="backButton"><i class="el-icon-arrow-left"></i></p>
    </router-link>

    <div class="colors">
      <el-color-picker class="color" v-model="tertiary_color" style="margin-right: 5%"></el-color-picker>
      <el-color-picker class="color" v-model="secondary_color"></el-color-picker>
      <el-color-picker class="color" v-model="primary_color"></el-color-picker>
    </div>

    <div id="preferences">
      <img id="image" src="../media/BaseAvatar.png" alt="">

      <el-input v-model="username" disabled>
        <template slot="prepend">Username: </template>
      </el-input>

      <el-input v-model="email">
        <template slot="prepend">Email: </template>
      </el-input>

      <el-input v-model="companyName">
        <template slot="prepend">Company: </template>
      </el-input>

      <el-button v-on:click="setUserInfo()">CHANGE</el-button>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    data() {
      return {
        primary_color: "",
        secondary_color: "",
        tertiary_color: "",
        colors: "",
        username: "",
        email: "",
        companyName: "",
      }
    },
    methods: {
      getUserInfo: function () {
        let app = this;

        this.username = this.$cookie.get('user');

        axios.post(`https://iiot.dave.eu/api/getUserInfo`, {
          username: this.username
        }).then(function (response) {

          let colors = response.data[0].colors.split(",")

          app.companyName = response.data[0].companyName || "";
          app.email = response.data[0].email || "";
          if(response.data[0].image !== null)
            document.getElementById("image").src = response.data[0].image;

          app.primary_color = colors[0].toString();
          app.secondary_color = colors[1].toString();
          app.tertiary_color = colors[2].toString();
        })
      },
      setUserInfo: function () {
        let app = this;

        this.username = this.$cookie.get('user');
        this.colors = `${this.primary_color},${this.secondary_color},${this.tertiary_color}`

        axios.post(`https://iiot.dave.eu/api/setUserInfo`, {
          username: this.username,
          companyName: this.companyName,
          email: this.email,
          colors: this.colors,
        }).then(function (response) {
          app.$notify({
            title: 'Ok!',
            message: response.data.message,
            type: 'success'
          })
          app.Themer(app.colors.split(","));
        }).catch(function (error) {
          app.$notify.error({
            title: 'ERROR!',
            message: error.data.message,
          });
        })
      },
      Themer(colors){
        let bodyStyles = document.body.style;
        bodyStyles.setProperty('--primary-color', colors[0]);
        bodyStyles.setProperty('--secondary-color', colors[1]);
        bodyStyles.setProperty('--tertiary-color', colors[2]);
      },

    },
    mounted: function () {
      this.getUserInfo();
    }
  }
</script>

<style scoped>
  #preferences{
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .el-input{
    width: 30%;
    margin-bottom: 2%;
  }
  .colors{
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
  }
  .color{
    margin: 2px;
  }

  #image{
    object-fit: cover;
    border-radius: 50%;
    border: 2px solid var(--secondary-color);
    margin-bottom: 2%;
    height: 200px;
    width: 200px;
  }

  #backButton{
    background-color: var(--tertiary-color);
    border: 1px solid var(--secondary-color);
    border-radius: 10px;
    display:inline-block;
    position: fixed;
    top: 11%;
    left: 3%;
    padding: 5px;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
    transition: .15s all ease-out;
  }
  #backButton:hover{
    cursor: pointer;
    transform: scale(1.1);
  }
</style>




// WEBPACK FOOTER //
// src/components/Preferences.vue